export default class CheckboxToRadio {

    constructor() {
        this.elems = document.querySelectorAll('.js-checkbox-to-radio');
    }
    
    setCheckboxBehaviour() {
        this.elems.forEach(item => {
            item.addEventListener('change', (evt) => {
                let currentElem = evt.target;
                this.elems.forEach(el => (el !== currentElem) ? el.checked = false : null);
            });
        });
    }

    init() {
        this.setCheckboxBehaviour();
    }

}
